import { MenuItem, TextField } from '@mui/material'
import { useAdminListarUsuariosFiscaisQuery, type UsuarioEmissorNfce } from '@/api'

const AJUDA_PADRAO = 'Usuário do Sischef com permissão fiscal — é ele que assina a NFC-e.'

function rotulo(usuario: UsuarioEmissorNfce): string {
    return usuario.nome ? `${usuario.nome} (${usuario.username})` : usuario.username
}

/**
 * Combo do emissor da NFC-e (modo TOTEM e totem checkout).
 *
 * Era um campo de texto livre, onde errar uma letra do login só aparecia lá na
 * frente, como nota que não sai — a lista vem do Sischef já sem SUPORTE e
 * REPRESENTANTE (ver `listarUsuariosEmissoresNfce` no backend).
 *
 * Um valor já gravado que não está mais na lista (usuário desativado, ou que virou
 * suporte) continua selecionável e marcado: some da lista mas não pode sumir da
 * configuração no primeiro save que o gestor der em outra aba.
 */
export function CampoUsuarioNfce({
    idConfig,
    valor,
    onChange,
    ajuda,
}: {
    idConfig: number
    valor: string | null
    onChange: (username: string | null) => void
    ajuda?: string
}) {
    const { data: usuarios, isLoading, isError } = useAdminListarUsuariosFiscaisQuery(idConfig)

    const lista = usuarios ?? []
    const atual = (valor ?? '').trim()
    const foraDaLista = !!atual && !lista.some((u) => u.username === atual)

    const helper = isError
        ? 'Não foi possível carregar os usuários agora. O valor atual foi mantido.'
        : foraDaLista
            ? `"${atual}" não está entre os usuários ativos da empresa — confira se ele ainda pode emitir.`
            : ajuda ?? AJUDA_PADRAO

    return (
        <TextField
            select
            fullWidth
            label="Usuário emissor da NFC-e"
            value={atual}
            onChange={(e) => onChange(e.target.value || null)}
            disabled={isLoading}
            error={foraDaLista}
            helperText={helper}
        >
            <MenuItem value="">
                <em>Não definido</em>
            </MenuItem>

            {foraDaLista && <MenuItem value={atual}>{atual}</MenuItem>}

            {lista.map((usuario) => (
                <MenuItem key={usuario.username} value={usuario.username}>
                    {rotulo(usuario)}
                </MenuItem>
            ))}
        </TextField>
    )
}

export default CampoUsuarioNfce
